module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.fe8c1b80.svg";